<div class="search-results-page">
    <div id="results-header" [hidden]="searchDataSource && searchDataSource.data.length === 0" class="row col-12 mb-3">
        <span id="results-keywords">
            Results for
            <strong> "{{searchText}}"</strong>
        </span>

        <span id="results-pagination">
            <mat-paginator [length]="searchResultDetails?.length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event"
                showFirstLastButtons>
            </mat-paginator>
        </span>
    </div>

    <div class="col-md-12 p-0 mb-4" *ngIf="searchDataSource && searchDataSource.data.length >0">
        <table aria-describedby="banner-list" aria-labelledby="banner-list" mat-table [dataSource]="searchDataSource" matSort class="col-md-12 banner-table mat-elevation-z8">
            <ng-container matColumnDef="searchResult">
                <th class="search-header-card" id="search-result-table-header" mat-header-cell *matHeaderCellDef>Result </th>

                <td mat-cell *matCellDef="let result">
                    <dl>
                        <dt>
                            <a *ngIf="result._source.contentDisplayName && result._source.contentDisplayName !== ''" href="{{result._source.contentLink}}"
                                class="search-result" (click)="openFileInNewTab($event, result._source.contentLink, result._source.contentType)">
                                <span class="search-title" [innerHTML]="result._source.contentDisplayName | highlight: searchText"></span>
                            </a>
                            <a *ngIf="result._source.contentDisplayName && result._source.contentDisplayName === ''" href="{{result._source.contentLink}}"
                                class="search-result" (click)="openFileInNewTab($event, result._source.contentLink, result._source.contentType)">
                                <span [innerHTML]="result._source.contentTitle | highlight: searchText"></span>
                            </a>
                        </dt>
                        <dd>
                            <a href="{{result._source.contentLink}}" class="search-result" (click)="openFileInNewTab($event, result._source.contentLink,result._source.contentType)">
                                <span [innerHTML]="result._source.contentDescription | highlight: searchText"></span>
                                <div class="result-source mt-2">{{result._source.contentLink}} </div>
                            </a>
                        </dd>
                    </dl>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <dl class="search-no-records" *ngIf="searchText && searchText !== '' && searchDataSource && searchDataSource.data.length === 0">
        <dt>No Results Found.</dt>
    </dl>
</div>